<template>
  <div class="body">
    <div class="storm_box">
      <StormBox></StormBox>
    </div>
    <div class="circle_body">
      <div
        class="circle_body_left"
        :class="{ circle_body_left_small: foldedStatus }"
      >
        <div class="page_name">圈子列表</div>
        <div class="circle_room_list">
          <RoomList ref="roomList" :foldedStatus="foldedStatus" />
        </div>
      </div>
      <div v-if="circleConfig.uid" class="circle_body_main">
        <Setup ref="setup" />
        <div class="circle_room_header">
          <div class="circle_name">
            <div>{{ circleConfig.title }}({{ circleConfig.user_total }})</div>
            <div class="live_data" @click="showLiveData = true">直播数据</div>
            <div class="live_data" @click="closeZhibo">关闭直播</div>
            <div
              class="live_data"
              @click="showMarketPoster"
              v-if="circleConfig.uid == 54 || circleConfig.uid == 66"
            >
              市场咨询海报
            </div>
          </div>
          <!--直播数据弹框-->
          <el-dialog v-model="showLiveData">
            <LiveData v-if="showLiveData" :circle_id="circleConfig.uid" />
          </el-dialog>
          <div class="handle_more_">
            <div class="flex ai_c">
              <span class="mr5">在线状态</span>
              <el-switch
                v-model="circleOnline"
                size="small"
                :active-value="1"
                :inactive-value="0"
                active-color="#4571e7"
                inactive-color="#BFBFBF"
                @change="changeCircleOnline"
              />
            </div>
            <div class="flex ai_c">
              <span class="mr5">桌面通知</span>
              <el-switch
                v-model="circleConfig.desktop_notice"
                size="small"
                :active-value="1"
                :inactive-value="2"
                active-color="#4571e7"
                inactive-color="#BFBFBF"
                @change="changeDesktopNotice"
              />
            </div>
            <div class="flex ai_c">
              <span class="mr5">声音提示</span>
              <el-switch
                v-model="circleConfig.sound_notice"
                :active-value="1"
                :inactive-value="2"
                active-color="#4571e7"
                inactive-color="#BFBFBF"
                @change="changeSoundNotice"
              />
            </div>
            <img
              class="icon_setup"
              src="@/assets/img/circleV2/icon_setup.png"
              alt=""
              @click="$refs.setup.open()"
            />
          </div>
        </div>
        <div class="circle_room_chat_box">
          <!-- 区域1 -->
          <div class="circle_room_chat_box-left">
            <div
              :class="{
                chat_condition_80: circleConfig.symbolList.length,
                chat_condition_40: !circleConfig.symbolList.length,
              }"
            >
              <div class="teacher_tabs">
                <RoundTabsTeacher ref="roundTabsTeacher" />
              </div>

              <div v-if="circleConfig.symbolList.length" class="symbol_tabs">
                <SymbolTabs ref="symbolTabs" />
              </div>
            </div>
            <ChatMessageList
              id="teacherChatList"
              ref="teacherChatList"
              :user-info="userInfo"
              :class="{
                h_80: circleConfig.symbolList.length,
                h_40: !circleConfig.symbolList.length,
              }"
            />
          </div>
          <!-- 区域2 -->
          <div class="circle_room_chat_box-right">
            <div
              :class="{
                chat_condition_80: strategyList.length,
                chat_condition_40: !strategyList.length,
              }"
            >
              <SymbolStorm ref="symbolStorm" />
              <RoundTabs1 ref="roundTabs1" :circle_id="circleConfig.uid" />
            </div>
            <ChatMessageList
              id="normalChatList"
              ref="normalChatList"
              :user-info="userInfo"
              :use-svip-list="useSvipList"
              :class="{ h_80: strategyList.length, h_40: !strategyList.length }"
            />
          </div>
        </div>
        <div class="circle_room_send_box">
          <ChatInputBox
            ref="chatInputBox"
            :circle_id="circleConfig.uid"
            :circle-talk-status="circleConfig.circle_status"
            :user-talk-status="circleConfig.user_status"
          />
        </div>
      </div>

      <div v-else class="circle_body_main">
        <CircleIntroduce />
      </div>
    </div>
    <!-- 市场咨询海报弹框 -->
    <MarketPoster
      :isMarketPoster="isMarketPoster"
      :circleId="circleConfig.uid"
      @update:isMarketPoster="isMarketPoster = $event"
    />

    <StormPopup ref="stormPopup" />
  </div>
</template>

<script>
import request from "@/utils/request";
import { Debounce } from "@/utils/debounce";
import CircleIntroduce from "@/components/circleV2/CircleIntroduce.vue";
import RoomList from "@/components/circleV2/RoomList.vue";
import ChatInputBox from "@/components/circleV2/ChatInputBox.vue";
import ChatMessageList from "@/components/circleV2/ChatMessageList.vue";
import RoundTabsTeacher from "@/components/circleV2/RoundTabsTeacher.vue";
import SymbolTabs from "@/components/circleV2/SymbolTabs.vue";
import SymbolStorm from "@/components/circleV2/SymbolStorm.vue";
import RoundTabs1 from "@/components/circleV2/RoundTabs1.vue";
import Setup from "@/components/circleV2/Setup.vue";
import StormBox from "@/components/StormBox.vue";
import StormPopup from "@/components/circleV2/StormPopup.vue";
import LiveData from "@/components/circleV2/LiveData.vue";
// 市场咨询海报
import MarketPoster from "@/components/circleV2/marketPoster.vue";
// import DisclaimerPopup from "@/components/circleV2/DisclaimerPopup.vue";
// import NoAuthPopup from "@/components/circleV2/NoAuthPopup.vue";
export default {
  components: {
    CircleIntroduce,
    RoomList,
    ChatInputBox,
    ChatMessageList,
    RoundTabsTeacher,
    SymbolTabs,
    SymbolStorm,
    RoundTabs1,
    Setup,
    StormBox,
    StormPopup,
    LiveData,
    MarketPoster,
    // DisclaimerPopup,
    // NoAuthPopup,
  },
  data() {
    return {
      circleConfig: {
        desktop_notice: 2,
        sound_notice: 2,
        teacherList: [],
        symbolList: [],
      },
      strategyList: [],
      timer: null,
      userInfo: {},
      circleOnline: 0,
      foldedStatus: true,
      showLiveData: false,
      useSvipList: null,
      queueMessage: null, // 消息发送队列
      retryTimers: null,
      isMarketPoster: false, //是否显示市场咨询海报
    };
  },
  mounted() {
    window.onmessageSocket = this.onmessage;
    this.useSvipList = new Set();
    this.getUserIndex();
    this.$refs.roomList.getCircleList();
    this.queueMessage = new Map();
    this.retryTimers = new Map();
  },
  methods: {
    // 市场咨询海报
    showMarketPoster() {
      // this.$refs.marketPoster.show();
      this.isMarketPoster = true;
    },
    clearRetryTimer(msgId) {
      const t = this.retryTimers && this.retryTimers.get(msgId);
      if (t) {
        clearTimeout(t);
        this.retryTimers.delete(msgId);
      }
    },
    resetRetryTimer(msgId) {
      this.clearRetryTimer(msgId);
      const self = this;
      const t = setTimeout(function () {
        if (!self.queueMessage || !self.queueMessage.has(msgId)) return;
        const lists = [self.$refs.teacherChatList, self.$refs.normalChatList];
        for (const list of lists) {
          if (!list) continue;
          const item = list.messageList.find((m) => m.msg_id === msgId);
          if (item && item.local) {
            Object.assign(item, { local: 0, send_sus: 1 });
            break;
          }
        }
      }, 10000);
      this.retryTimers.set(msgId, t);
    },
    //关闭直播
    closeZhibo() {
      this.$confirm("确定关闭直播, 是否继续?", "提示", {
        confirmButtonText: "关闭",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.closeLiveApi();
      });
    },
    closeLiveApi: Debounce(async function () {
      const res = await request.post("/teacher/circle/closeLive", {
        circle_id: this.circleConfig.uid,
      });
      if (res.code === 1) {
        this.$message({
          type: "success",
          message: "关闭成功",
        });
        this.useSvipList.clear();
      }
    }),
    // 消息发送存本地队列
    queuePush(e) {
      // 相同 msg_id 视为同一条消息（如失败后重试），避免重复插入新消息
      if (this.queueMessage.has(e.msg_id)) {
        const list = e.symbol
          ? this.$refs.teacherChatList?.messageList
          : this.$refs.normalChatList?.messageList;
        if (Array.isArray(list)) {
          const item = list.find((m) => m.msg_id === e.msg_id);
          if (item) {
            Object.assign(item, { local: 1, send_sus: 0 });
          }
        }
        this.resetRetryTimer(e.msg_id);
        return;
      }
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的，所以加1
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const userInfo = this.userInfo;
      const createtimeText = `${month}-${day} ${hours}:${minutes}:${seconds}`;
      // 生成本地匹配键：服务端回显不含客户端msg_id，用此键匹配（分钟精度避免服务端时间差）
      // 加msg_id确保同一分钟多条消息不会互相干扰
      const localKey =
        `${month}-${day} ${hours}:${minutes}` +
        "_" +
        userInfo.user_id +
        "_" +
        (e.content || "") +
        "_" +
        e.msg_id;
      const messageInfo = {
        content: e.content,
        createtime: "",
        createtime_text: createtimeText,
        images: e.images,
        id: "",
        question: e.question || 0,
        message_type: e.message_type || "text",
        reply_content: "",
        reply_images: "",
        reply_id: e.reply_id || "",
        reply_question: "",
        reply_user_id: "",
        reply_user_nickname: "",
        reply_message_type: "",
        symbol: e.symbol || "",
        symbol_name: e.symbol_name || "",
        teacher_id: e.teacher_id,
        to_user_id: e.to_user_id,
        user: {
          avatar: userInfo.avatar,
          id: userInfo.id,
          is_teacher: userInfo.is_teacher,
          mobile: userInfo.mobile,
          nickname: userInfo.nickname,
        },
        user_id: userInfo.user_id,
        local: 1,
        msg_id: e.msg_id,
        send_sus: 0,
        message_open: e.message_open,
        _localKey: localKey,
      };
      this.queueMessage.set(e.msg_id, messageInfo);
      //判断是不是品种消息
      if (e.symbol) {
        this.$refs.teacherChatList.messageListPush(messageInfo);
      } else {
        this.$refs.normalChatList.messageListPush(messageInfo);
      }
      // 安全超时：5秒后如果消息仍在待确认队列中，标记为失败
      const self = this;
      const msgId = e.msg_id;
      setTimeout(function () {
        if (self.queueMessage.has(msgId)) {
          self.queuePushSus(msgId);
        }
      }, 5000);
      this.resetRetryTimer(msgId);
    },
    // 根据服务端 symbol 从错误列表中移除本地消息
    removeMsgFromList(list, data) {
      if (!list) return;
      const messageList = list.messageList;
      // 优先用 msg_id 匹配
      if (data.msg_id) {
        const idx = messageList.findIndex((m) => m.msg_id === data.msg_id);
        if (idx > -1) {
          messageList.splice(idx, 1);
          return;
        }
      }
      // 兜底：用时间+用户+内容匹配本地消息
      const minuteText = data.createtime_text
        ? data.createtime_text.substring(0, 16)
        : "";
      if (!minuteText) return;
      const idx = messageList.findIndex(
        (m) =>
          m.createtime_text &&
          m.createtime_text.substring(0, 16) === minuteText &&
          String(m.user_id) === String(data.user_id) &&
          (m.content || "") === (data.content || "")
      );
      if (idx > -1) {
        messageList.splice(idx, 1);
      }
    },
    // 通过本地匹配键清除loading状态
    clearLocalByKey(data) {
      if (!data.createtime_text || !data.user_id) return false;
      // 优先用queueMessage精确匹配：遍历待确认队列，找时间和内容匹配的本地消息
      const minuteText = data.createtime_text.substring(0, 16);
      for (const [msgId, qItem] of this.queueMessage) {
        if (
          qItem.createtime_text &&
          qItem.createtime_text.substring(0, 16) === minuteText &&
          String(qItem.user_id) === String(data.user_id) &&
          (qItem.content || "") === (data.content || "")
        ) {
          // 找到对应的本地消息，清除loading
          const lists = [this.$refs.teacherChatList, this.$refs.normalChatList];
          for (const list of lists) {
            if (!list) continue;
            const item = list.messageList.find((m) => m.msg_id === msgId);
            if (item) {
              Object.assign(item, {
                local: 0,
                send_sus: 0,
                id: data.chat_id,
                createtime: data.createtime,
              });
              this.queueMessage.delete(msgId);
              this.clearRetryTimer(msgId);
              return true;
            }
          }
        }
      }
      return false;
    },
    // 发送失败--重新发送
    queuePushSus(msgId, isSend = false) {
      const qItem = this.queueMessage.get(msgId);
      if (!qItem) return;
      let messageList = [];
      if (qItem.symbol) {
        messageList = this.$refs.teacherChatList.messageList;
      } else {
        messageList = this.$refs.normalChatList.messageList;
      }

      const item = messageList.find((item) => item.msg_id === msgId);
      if (!item) return;
      const obj = { local: 0, send_sus: 1 };
      if (isSend) {
        this.resetRetryTimer(msgId);
        // 连续点击”重试”：只重置倒计时，不重复发送
        if (item.local) {
          return;
        }
        obj.local = 1;
        obj.send_sus = 0;
        const objSend = {
          type: "chat_teacher_send",
          to_user_id: item.to_user_id,
          teacher_id: item.teacher_id,
          content: item.content,
          chat_type: 4,
          config: {
            platform: "pushWeb",
          },
          reply_id: item.reply_id,
          question: item.question,
          symbol: item.symbol,
          symbol_name: item.symbol_name,
          message_type: item.message_type || "text",
          images: item.images || "",
          msg_id: msgId,
          noAddImages: item.images ? 1 : 0,
          message_open: item.message_open,
        };
        // retrySend 内部处理：已连接则 ws.send()，未连接则触发重连后补发
        this.$refs.chatInputBox.retrySend(objSend);
      }
      Object.assign(item, obj);
    },
    // 重连成功，重发所有待发送消息（逐个发送，避免同时发送导致丢失）
    resendPendingMessages() {
      const pending = [];
      for (const [msgId, qItem] of this.queueMessage) {
        let messageList = [];
        if (qItem.symbol) {
          messageList = this.$refs.teacherChatList.messageList;
        } else {
          messageList = this.$refs.normalChatList.messageList;
        }
        const item = messageList.find((m) => m.msg_id === msgId);
        if (item) {
          Object.assign(item, { local: 1, send_sus: 0 });
          this.resetRetryTimer(msgId);
          pending.push({
            msgId,
            symbol: !!qItem.symbol,
            objSend: {
              type: "chat_teacher_send",
              to_user_id: item.to_user_id,
              teacher_id: item.teacher_id,
              content: item.content,
              chat_type: 4,
              config: { platform: "pushWeb" },
              reply_id: item.reply_id,
              question: item.question,
              symbol: item.symbol,
              symbol_name: item.symbol_name,
              message_type: item.message_type || "text",
              images: item.images || "",
              msg_id: msgId,
              noAddImages: item.images ? 1 : 0,
              message_open: item.message_open,
            },
          });
        }
      }
      // 逐个发送，每条间隔100ms
      const self = this;
      pending.forEach(function (item, index) {
        setTimeout(function () {
          self.$refs.chatInputBox.retrySend(item.objSend);
        }, index * 100);
      });
    },
    // 重连失败，标记所有待发送消息为失败
    markPendingAsFailed() {
      for (const [msgId, qItem] of this.queueMessage) {
        let messageList = [];
        if (qItem.symbol) {
          messageList = this.$refs.teacherChatList.messageList;
        } else {
          messageList = this.$refs.normalChatList.messageList;
        }
        const item = messageList.find((m) => m.msg_id === msgId);
        if (item) {
          Object.assign(item, { local: 0, send_sus: 1 });
        }
      }
    },
    onmessage(e) {
      const redata = JSON.parse(e.data);
      const circleConfig = this.circleConfig;
      const userInfo = this.userInfo;
      switch (redata.type) {
        // ---------用于接收圈子消息
        case "chat_teacher_accept":
          if (redata.chat_type * 1 === 4) {
            // 同步圈子列表最新展示消息
            if (
              redata.message_type !== "new_join" &&
              ((!redata.symbol && !redata.question && !redata.reply_question) ||
                redata.user_id * 1 === userInfo.id * 1 ||
                redata.reply_user_id * 1 === userInfo.id * 1 ||
                (redata.user_info.is_teacher && redata.symbol))
            ) {
              this.$refs.roomList.updateNewMessage(redata);
            }
            // 判断如果当前有选中的圈子，并且属于当前圈子的消息则同步
            if (circleConfig.uid * 1 === redata.to_user_id * 1) {
              // 先尝试用本地匹配键清除loading状态（服务端回显不含客户端msg_id）
              this.clearLocalByKey(redata);
              // 根据返回值中的 symbol 判断消息类型，有品种信息只在老师列表渲染
              if (redata.symbol) {
                this.removeMsgFromList(this.$refs.normalChatList, redata);
                this.$refs.teacherChatList.updateNewMessage(redata);
              } else {
                this.removeMsgFromList(this.$refs.teacherChatList, redata);
                this.$refs.normalChatList.updateNewMessage(redata);
              }
              // 收到服务端回执，从待确认队列中移除，防止 isSend 误判为失败
              if (redata.msg_id && this.queueMessage.has(redata.msg_id)) {
                this.queueMessage.delete(redata.msg_id);
                this.clearRetryTimer(redata.msg_id);
              }
              // 如果接收到不是自己发送的消息则进行提示
              if (redata.user_id * 1 !== userInfo.id * 1) {
                this.pageTitleAnimationStart();
              }
              if (redata.question) {
                this.roundTabs1ChangeMyUnReadNum(1);
              }
              // 如果是老师发送并且携带品种信息的消息，则更新品种
              if (redata.user_info.is_teacher && redata.symbol) {
                if (this.circleConfig.symbolList.length) {
                  this.$refs.symbolTabs.pushSymbolList({
                    symbol: redata.symbol,
                    symbol_name: redata.symbol_name,
                    teacher_id: redata.teacher_id,
                  });
                } else {
                  this.circleConfig.symbolList = [
                    {
                      symbol: redata.symbol,
                      symbol_name: redata.symbol_name,
                      teacher_id: redata.teacher_id,
                    },
                  ];
                  setTimeout(() => {
                    this.$refs.symbolTabs.init({
                      circle_id: circleConfig.uid,
                      teacher_id: redata.teacher_id,
                      symbolList: this.circleConfig.symbolList,
                    });
                  });
                }
              }
            }
          }
          break;
        // ---------用于接收圈子通知
        case "circle_message":
          switch (redata.content.type) {
            case "message":
              // 删除发言
              if (circleConfig.uid * 1 === redata.content.circle_id * 1) {
                this.$refs.teacherChatList.handleDeleteMessage(
                  redata.content.id
                );
                this.$refs.normalChatList.handleDeleteMessage(
                  redata.content.id
                );
              }
              break;
            case "circle":
              // 圈子发言状态变更
              if (circleConfig.uid * 1 === redata.content.circle_id * 1) {
                if (redata.content.status * 1 === 0) {
                  this.$message.error("全员禁言开启");
                } else {
                  this.$message.success("全员禁言关闭");
                }
                this.circleConfig.circle_status = redata.content.status * 1;
              }
              break;
            case "user":
              // 用户发言状态变更
              if (circleConfig.uid * 1 === redata.content.circle_id * 1) {
                if (redata.content.status * 1 === 0) {
                  this.$message.error("您已被禁言");
                } else {
                  this.$message.success("您已解除禁言");
                }
                this.circleConfig.user_status = redata.content.status * 1;
              }
              break;
          }
          break;
        // ---------用于接收圈子老师状态改变
        case "circle_teacher_status":
          if (circleConfig.uid * 1) {
            this.$refs.roundTabsTeacher.updateTeacherOnlineStatus(redata);
          }
          break;
        // ---------svip加入直播间
        case "join_live_circle_accept":
          this.useSvipList.add(redata.user_id + redata.circle_id);
          break;
        // ---------svip离开直播间
        case "leave_live_circle_accept":
          this.useSvipList.delete(redata.user_id + redata.circle_id);
          break;
        // ---------websocket出现错误进行提示
        case "error":
          this.$message.error(redata.content);
          break;
      }
    },
    async getCircleOnline() {
      const res = await request.post("/teacher/circle/getCircleOnline");
      this.circleOnline = res.data.circle_online;
    },
    changeCircleOnline: Debounce(async function (e) {
      const res = await request.post("/teacher/circle/changeCircleOnline", {
        circle_online: this.circleOnline,
      });
      this.getCircleOnline();
    }),
    async getUserIndex() {
      const res = await request.post("/teacher/user/index");
      this.userInfo = res.data.userinfo;
    },
    pageTitleAnimationStart() {
      let n = 0;
      if (this.timer) {
        // console.error('=====有正在执行的动画')
        return;
      }
      this.timer = setInterval(() => {
        n++;
        document.title =
          n % 2 === 0 ? "【______________】" : "【您有新的消息】";
        if (n >= 10) {
          clearInterval(this.timer);
          this.timer = null;
          document.title = "聊天(内测版)";
          // console.error('动画结束=====')
        }
      }, 500);
    },
    getTipValue() {
      return {
        desktopNotice: this.circleConfig.desktop_notice,
        soundNotice: this.circleConfig.sound_notice,
      };
    },
    changeDesktopNotice: Debounce(function (e) {
      if (e === 1) {
        this.$handleNotification({
          title: "V策财经 - www.i-vce.com",
          body: "桌面系统级通知开启成功！",
          tag: Math.round(new Date() / 1000),
          renotify: true,
          requireInteraction: true,
          icon: require("@/assets/img/icon_logo1.png"),
        })
          .then(() => {
            this.circleConfig.desktop_notice = 1;
            this.setUserCircle({
              circle_id: this.circleConfig.uid,
              desktop_notice: 1,
            });
          })
          .catch((err) => {
            this.circleConfig.desktop_notice = 2;
            console.error("捕获到了异常", err);
          });
      } else {
        this.setUserCircle({
          circle_id: this.circleConfig.uid,
          desktop_notice: 2,
        });
      }
    }),
    changeSoundNotice: Debounce(function (e) {
      this.circleConfig.sound_notice = e;
      this.setUserCircle({
        circle_id: this.circleConfig.uid,
        sound_notice: e,
      });
    }),
    async setUserCircle(obj) {
      await request.post("/api/circle/setUserCircle", obj);
    },
    async getCircleConfig(obj) {
      const res = await request.post("/teacher/circle/getCircleConfig", {
        circle_id: obj.circle_id,
        teacher_id: obj.teacher_id,
      });
      const circleConfig = res.data;
      this.circleConfig = circleConfig;
      if (circleConfig.disclaimer_show) {
        this.openPopup({
          type: "disclaimerPopup",
          data: {
            circle_id: obj.circle_id,
            disclaimer: circleConfig.disclaimer,
            circleSecond: 5,
          },
        });
      }
      this.getOnLineChatCricleList(obj);
      setTimeout(() => {
        this.getCircleStrategy();
        this.$refs.setup.setData({
          circle_id: obj.circle_id,
          notice: circleConfig.notice,
          disclaimer: circleConfig.disclaimer,
        });
        this.$refs.roundTabsTeacher.init({
          circle_id: obj.circle_id,
          teacher_id: obj.teacher_id,
          teacherList: circleConfig.teacherList,
        });
        this.getSymbolList({
          circle_id: obj.circle_id,
          teacher_id: obj.teacher_id,
        });
        this.$refs.chatInputBox.restoreDefault(true);
        this.getCircleOnline();
        this.roundTabs1ChangeMyUnReadNum(circleConfig.my_unread_num);
      });
    },
    //SVIP直播间人数初始化
    async getOnLineChatCricleList(obj) {
      const res = await request.post(
        "/teacher/circle/getOnLineChatCricleList",
        {
          circle_id: obj.circle_id,
        }
      );
      if (res.data.length) {
        this.useSvipList = null;
        this.useSvipList = new Set(
          res.data.map((item) => item.user_id + obj.circle_id)
        );
      }
    },
    async getCircleStrategy() {
      // const res = await request.post("/api/circle/getCircleStrategy", {
      const res = await request.post("/teacher/circle/getCircleStrategy", {
        circle_id: this.circleConfig.uid,
      });
      const strategyList = res.data;
      this.strategyList = strategyList;
      this.$refs.symbolStorm.init({
        list: strategyList,
        logo: strategyList.length ? strategyList[0].logo : "",
      });
      this.$refs.roundTabs1.changTabs(0);
    },
    roundTabs1ChangeMyUnReadNum(e) {
      this.$refs.roundTabs1.changeMyUnReadNum(e);
    },
    async getSymbolList(obj) {
      const res = await request.post("/api/circle/getChatSymbolList", {
        circle_id: obj.circle_id,
        teacher_id: obj.teacher_id,
      });
      const symbolList = res.data;
      this.circleConfig.symbolList = symbolList;
      setTimeout(() => {
        this.$refs.symbolTabs &&
          this.$refs.symbolTabs.init({
            circle_id: obj.circle_id,
            teacher_id: obj.teacher_id,
            symbolList,
          });
        this.getChatMessageList1({
          circle_id: obj.circle_id,
          teacher_id: obj.teacher_id,
          symbol: "",
        });
      });
    },
    getChatMessageList1(obj) {
      this.$refs.teacherChatList.init({
        circle_id: obj.circle_id,
        teacher_id: obj.teacher_id,
        symbol: obj.symbol,
        createtime: "",
        type: 3,
      });
    },
    getChatMessageList2(obj) {
      this.$refs.normalChatList.init({
        circle_id: obj.circle_id,
        teacher_id: null,
        symbol: "",
        createtime: "",
        type: obj.type,
      });
    },
    openPopup(e) {
      this.$refs[`${e.type}`].open(e.data);
    },
  },
};
</script>

<style>
.el-switch__core {
  width: 30px !important;
  height: 18px;
}
.el-switch__core::after {
  width: 14px;
  height: 14px;
}
.el-switch.is-checked .el-switch__core::after {
  margin-left: -15px;
}
</style>
<style scoped>
.body {
  background-color: #eaeaea;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 12px;
  display: flex;
  column-gap: 12px;
}

.storm_box {
  width: 100%;
}

.circle_body {
  width: calc(1200px - 167px);
  background: #f0f0f0;
  border-radius: 8px;
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  /* margin: 12px auto 0; */
  /* height: calc(100vh - 12px - 12px); */
  height: 100%;
  min-height: 620px;
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
}

.circle_body_left {
  width: 260px;
  box-sizing: border-box;
  border-right: 1px solid #dfdfdf;
  flex-shrink: 0;
}

.circle_body_left_small {
  width: 93px !important;
}

.circle_body_main {
  position: relative;
  width: 100%;
}

.page_name {
  box-sizing: border-box;
  border-bottom: 1px solid #dfdfdf;
  width: 100%;
  height: 56px;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background-color: #fff;
}

.circle_room_list {
  background-color: #fff;
  height: calc(100% - 56px);
}

.circle_room_header {
  height: 56px;
  box-sizing: border-box;
  border-bottom: 1px solid #dfdfdf;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.circle_room_chat_box {
  height: calc(100% - 56px - 160px);
  box-sizing: border-box;
  border-bottom: 1px solid #dfdfdf;
  display: flex;
}

.circle_room_chat_box-left {
  width: calc(100% - 360px);
  height: 100%;
  background-color: #f9f9f9;
}

.circle_room_chat_box-right {
  width: 360px;
  height: 100%;
  background-color: #f0f0f0;
  box-sizing: border-box;
  border-left: 1px solid #dfdfdf;
}

.circle_room_send_box {
  height: 160px;
  box-sizing: border-box;
  background-color: #fff;
}

.circle_name {
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  display: flex;
  grid-gap: 10px;
}
.circle_name .live_data {
  font-size: 12px;
  background-color: #4571e7;
  border: 1px solid #4571e7;
  color: #fff;
  padding: 3px 10px;
  border-radius: 20px;
  cursor: pointer;
}
.handle_more_ {
  display: flex;
  align-items: center;
  column-gap: 12px;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
}

.icon_setup {
  width: 30px;
  height: 30px;
  display: block;
  cursor: pointer;
  user-select: none;
}

.chat_condition_80 {
  position: relative;
  width: 100%;
  height: 80px;
}

.chat_condition_40 {
  position: relative;
  width: 100%;
  height: 40px;
}

.teacher_tabs {
  width: 100%;
  height: 40px;
}

.symbol_tabs {
  width: 100%;
  position: absolute;
  z-index: 10;
  top: 40px;
  left: 0;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
}

.h_80 {
  height: calc(100% - 80px);
}

.h_40 {
  height: calc(100% - 40px);
}
</style>
